import http from '@/utils/http'


/**
 * 门禁分页列表
*/
export function getAccessList(data) {
    return http({
        method: 'post',
        url: '/new/mj/devices/paging',
        data
    })
}


/**
 * 获取子食堂列表
*/
export function getEntityList(params) {
    return http({
        method: 'get',
        url: '/system/xcwsSubEntity/available/list',
        params
    })
}


/**
 * 新增门禁设备
*/
export function addAccess(data) {
    return http({
        method: 'post',
        url: '/new/mj/devices/add',
        data
    })
}


/**
 * 编辑门禁设备
*/
export function editAccess(data) {
    return http({
        method: 'post',
        url: '/new/mj/devices/update',
        data
    })
}


/**
 * 启用门禁设备
*/
export function changeStatusEnable(params) {
    return http({
        method: 'post',
        url: '/new/mj/devices/enable',
        params
    })
}


/**
 * 禁用门禁设备
*/
export function changeStatusDisable(params) {
    return http({
        method: 'post',
        url: '/new/mj/devices/disable',
        params
    })
}


/**
 * 删除门禁设备
*/
export function deleteAccess(params) {
    return http({
        method: 'post',
        url: '/new/mj/devices/delete',
        params
    })
}